<template>
<div class="dropdown" style="width: 100%;">
    <button class="btn btn-secondary dropdown-toggle utilaj_item" type="button" data-bs-toggle="dropdown" aria-expanded="false" :disabled="disabled">
        {{utilaj}}
    </button>
    <ul class="dropdown-menu" style="width: 100%;">
        <li><input type="search" class="form-control search" placeholder="Selecteaza..." v-model="cauta_utilaj" @click.stop :disabled="disabled"></li>
        <li v-for="option in optiuniFiltrate" v-bind:key="option.id">
            <button class="dropdown-item utilaj_item" :class="{'optiune-favorita': esteFavorit(option), 'optiune-cu-subtip': includeSubtip}" :title="eticheta(option)" type="button" :disabled="disabled" @click="selecteaza(option)">
                <span v-if="esteFavorit(option)" aria-hidden="true">★ </span>{{ eticheta(option) }}
            </button>
        </li>
    </ul>
</div>
</template>

<script>
export default {
        name: 'FSearchSelect',
        data () {
                return {
                        cauta_utilaj: '',
                }
        },
        props: {
                options: { type: Array, default: () => [] },
                utilaj: { type: String, default: '' },
                disabled: { type: Boolean, default: false },
                favoriteIds: { type: Array, default: () => [] },
                includeSubtip: { type: Boolean, default: false },
        },
        emits: ['utilaj_selectat'],
        computed: {
                rangFavorite() {
                        return new Map(this.favoriteIds.map((id, index) => [String(id), index]));
                },
                optiuniFiltrate() {
                        const filtru = this.cauta_utilaj.trim().toLocaleUpperCase('ro');
                        const optiuni = this.options.filter(option =>
                                this.eticheta(option).toLocaleUpperCase('ro').includes(filtru));
                        return optiuni
                                .map((option, index) => ({ option, index, rang: this.rangFavorite.get(String(option.id)) }))
                                .sort((prima, aDoua) => {
                                        const rangPrima = prima.rang ?? Number.MAX_SAFE_INTEGER;
                                        const rangADoua = aDoua.rang ?? Number.MAX_SAFE_INTEGER;
                                        return rangPrima - rangADoua || prima.index - aDoua.index;
                                })
                                .map(({ option }) => option);
                },
        },
        methods:{
                eticheta(option) {
                        if (this.includeSubtip) {
                                return [option.inventar, option.subtip, option.producator, option.model]
                                        .filter(valoare => valoare != null && valoare !== '')
                                        .join(' - ');
                        }
                        return `${option.inventar || ''}-${option.producator || ''}, ${option.model || ''}`;
                },
                esteFavorit(option) {
                        return this.rangFavorite.has(String(option.id));
                },
                selecteaza: function(dictionar){
                        if (this.disabled) return;
                        this.cauta_utilaj = '';
                        this.$emit('utilaj_selectat', dictionar)
                }
        }
}
</script>

<style scoped>
.utilaj_item {
    display: block;
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.optiune-favorita {
    font-weight: 700;
}

.optiune-cu-subtip {
    white-space: normal;
    overflow: visible;
    text-overflow: clip;
    text-align: left;
}
</style>
